var map = {
	"./american-flag-icon.svg": "a806",
	"./background-lines.svg": "a847",
	"./building-icon.svg": "15a7",
	"./canadian-flag-icon.svg": "747d",
	"./current-calendar-icon.svg": "36bc",
	"./delos-logo.svg": "41b1",
	"./duration-icon.svg": "4632",
	"./filter-icon.svg": "43e9",
	"./icons-top.svg": "5391",
	"./logo-dark.svg": "34ef",
	"./logo-grayscale-dark.svg": "e846",
	"./mask-icon.svg": "e4eb",
	"./oa-icon.svg": "60e2",
	"./occupancy-icon.svg": "9fe1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";